const exactHostnames = [
  'furever.dev',
  'poseyoga.fit',
  'stripe-connect-furever.onrender.com',
  'stripe-connect-test.onrender.com', // Connect test app on Render
  'stripe-connect-furever-ops-test.onrender.com',
  'property-management-tau.vercel.app',
  'gym-management-mvhg.vercel.app',
  'coffee-shop-management-liard.vercel.app',
  'connecttest.onrender.com',
  'localhost',
  'stripe.com',
  '127.0.0.1',
  'hamster-dance.onrender.com', // App Platform demo for Connect App Distribution
  'express.stripe.dev', // Express demo site
];

// Leading dots ensure suffix matches start at a subdomain boundary.
const hostnameSuffixes = [
  '.vercelapp.stripe.dev', // Stripe vercel apps are all within this
  '.stripedemos.com',
  '.stripe.com',
  '.stripe.me',
];

export const isStripeDomain = (windowUrl: URL): boolean => {
  const hostname = windowUrl.hostname.toLowerCase();
  return (
    exactHostnames.includes(hostname) ||
    hostnameSuffixes.some((suffix) => hostname.endsWith(suffix))
  );
};
